import { render, staticRenderFns } from "./CanteenHeader.vue?vue&type=template&id=6f75e9b5&"
import script from "./CanteenHeader.vue?vue&type=script&lang=js&"
export * from "./CanteenHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports